import {Component} from "react";
import {accountLogout, getAccount} from "../util/account";
import {WindowParamContext} from "../../library/context/WindowContext";
import {AdminNav, EntityType, getEntityList} from "./components/admin/AdminNav";
import {ColumnUnit} from "../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../library/basic/size";
import {LoginPanel} from "./components/admin/LoginPanel";
import {ColumnAttr} from "../../library/basic/compose";
import {ExchangeCodePanel} from "./components/admin/panels/ExchangeCodePanel";
import {OpinionPanel} from "./components/admin/panels/OpinionPanel";
import {SystemMessagePanel} from "./components/admin/panels/SystemMessagePanel";

export class AdminPage extends Component {
    static contextType = WindowParamContext;

    state: {
        account: String
        currentPanel: EntityType
    } = {
        account: getAccount(),
        currentPanel: getEntityList()[0]
    }

    logout() {
        accountLogout()
        this.setState(prevState => (Object.assign(prevState, {account: ""})))
    }

    componentDidMount() {
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;

                    return (
                        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw", wp.currHeight + "px")}>
                            {
                                this.state.account == '' &&
                                <LoginPanel/>
                            }
                            {
                                this.state.account != '' &&
                                <ColumnUnit
                                    sizeAttr={new SizeAttr(wp, "100vw")}
                                    customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                        "minHeight": "100vh"
                                    })}>
                                    {AdminNav(wp, this.state.currentPanel, (newPanel: string) => {
                                        this.setState(prevState => (Object.assign(prevState, {currentPanel: newPanel})))
                                    }, () => {
                                        this.logout()
                                    })}

                                    {
                                        this.state.currentPanel == "exchange_code" &&
                                        <ExchangeCodePanel/>
                                    }
                                    {
                                        this.state.currentPanel == "opinion" &&
                                        <OpinionPanel/>
                                    }
                                    {
                                        this.state.currentPanel == "system_message" &&
                                        <SystemMessagePanel/>
                                    }
                                </ColumnUnit>
                            }
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}